<template>
  <div v-show="popShow" style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.7)">
    <div style="width:100%;height:100%;position:relative">
      <div style="height:3.5rem"></div>
      <div style="box-sizing:border-box;width:50rem;height:calc( 100vh - 9.4rem );margin:0 auto;background:#ffffff;border-radius:2rem;border: 0.2rem solid #FF9455;box-shadow:0 4px 16px #FF9455;position:relative">
        <img src="../assets/alert_close.png" style="width:3.2rem;height:3.2rem;position:absolute;top:0;right:-5.2rem;cursor: pointer;" @click="hide"/>
        <div style="width: 50rem;margin-left:-0.2rem;height: 4rem;line-height: 4rem;background: linear-gradient(0deg, #FF646F, #FF9455);border-radius: 1.8rem 1.8rem 0px 0px;text-align:center;font-size:1.8rem;color:#ffffff">
          排行榜
        </div>
        <div style="padding:0 2.2rem;height:calc( 100% - 4rem );overflow: scroll;" ref="bScrollComp" class="bScrollComp">
          <div ref="scrollContainerComp">
            <div v-for="(item,index) in list" :key="index" style="box-sizing:border-box;padding:1rem 0rem" :style="index>0?'border-top:1px solid #efefef':''" class="flexBetween">
              <div class="flexAc">
                <div style="width:3.6rem">
                  <img v-if="index==0" src="../assets/rank1.png" style="width:3.6rem" />
                  <img v-if="index==1" src="../assets/rank2.png" style="width:3.6rem" />
                  <img v-if="index==2" src="../assets/rank3.png" style="width:3.6rem" />
                </div>
                <div style="margin:0 1.5rem 0 1rem">
                  <div v-if="index==0" style="background: linear-gradient(0deg, #FFD86F 0%, #FFBA00 100%);border-radius: 50%;height:6.1rem;width:6.1rem" class="flexCenter">
                      <img :src="item.avatar?item.avatar:require('../assets/default_avatar.png')" style="width:5.5rem;height:5.5rem;border-radius:50%"/>
                  </div>
                  <div v-else-if="index==1" style="background: linear-gradient(0deg, #CECECE 0%, #B6B6B6 100%);border-radius: 50%;height:6.1rem;width:6.1rem" class="flexCenter">
                      <img :src="item.avatar?item.avatar:require('../assets/default_avatar.png')" style="width:5.5rem;height:5.5rem;border-radius:50%"/>
                  </div>
                  <div v-else-if="index==2" style="background: linear-gradient(0deg, #FFA178 0%, #FF8D5B 100%);border-radius: 50%;height:6.1rem;width:6.1rem" class="flexCenter">
                      <img :src="item.avatar?item.avatar:require('../assets/default_avatar.png')" style="width:5.5rem;height:5.5rem;border-radius:50%"/>
                  </div>
                  <div v-else style="background: linear-gradient(0deg, #50B8EF 0%, #16A0E9 100%);border-radius: 50%;height:6.1rem;width:6.1rem" class="flexCenter">
                      <img :src="item.avatar?item.avatar:require('../assets/default_avatar.png')" style="width:5.5rem;height:5.5rem;border-radius:50%"/>
                  </div>
                </div>
                <div style="font-size:2rem;color:#0F85DB">{{item.nickname}}</div>
              </div>
              <div class="flexAc">
                <img src="../assets/icon_coin.png" style="width:2rem;height:2rem;margin-right:0.5rem" />
                <div style="font-size:2rem;color:#0F85DB">{{item.coin_num}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width:100%;position:absolute;bottom:2.6rem;left:0" class="flexCenter">
        <div>
          <img src="../assets/class_arrow_up.png" style="width:3.6rem" @click="scrollPrev('bScrollComp')"/>
          <img src="../assets/class_arrow_down.png" style="width:3.6rem;margin-left:2.5rem" @click="scrollNext('bScrollComp')"/>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
// import BScroll from 'better-scroll'

export default {
  name: 'RankList',
  props: {
  },
  data(){
    return{
      scrollOffset:0,
      list:[],
      popShow:false
    }
  },
  mounted() {
  },
  methods:{
    scrollPrev(pref) {
      let pobj=this.$refs[pref]
      let ph=pobj.offsetHeight;

      let targetY=0;
      if(this.scrollOffset<=ph){
        targetY=0
      }else{
        targetY=this.scrollOffset-ph
      }
      pobj.scrollTo(0,targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset=targetY
    },
    scrollNext(pref){
      let pobj=this.$refs[pref]
      let ph=pobj.offsetHeight;
      let sh=pobj.scrollHeight;

      let targetY=0;
      if(this.scrollOffset+ph>=sh){
        targetY=sh-ph
      }else{
        targetY=this.scrollOffset+ph
      }
      pobj.scrollTo(0,targetY)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset=targetY
    },
    show(id){
      this.$http.post("/api/v2/handwriting/BigScreen/get_class_student_Leaderboard_list",{class_id:id}).then(res=>{
        if(res.code=="200"){
          let list=res.data;
          this.list=list;
          this.$nextTick(()=>{
            this.$refs['bScrollComp'].addEventListener("scroll",(e)=>{
              this.scrollOffset=e.target.scrollTop
            })
          })
          this.popShow=true;
        }
      })
      
    },
    hide(){
      if(this.bScroll){
        this.bScroll.destroy();
        this.bScroll=null;
      }
      this.popShow=false;
    }
  },
}
</script>

<style scoped>
.bScrollComp::-webkit-scrollbar {
  display: none;
}
</style>
